import { ThumbnailProps } from './Thumbnail.typed';
import * as Styled from './Thumbnail.styled';

export function Thumbnail(props: ThumbnailProps) {
  const {
    children,
    image,
    aspectRatio = [1, 1],
    elevated = false,
    placeholder,
    presentation = false,
    fit = 'cover',
    alt = '',
    ...rest
  } = props;
  return (
    <Styled.Thumbnail
      {...(presentation && !!image && { image })}
      aspectRatio={aspectRatio}
      elevated={elevated}
      fit={fit}
      {...rest}
    >
      {image && !presentation && <img src={image} alt={alt} />}
      {!image && !!placeholder && (
        <div>
          <Styled.Placeholder>{placeholder}</Styled.Placeholder>
        </div>
      )}
      {!!children && <Styled.Body>{children}</Styled.Body>}
    </Styled.Thumbnail>
  );
}

export default Thumbnail;
